import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/onboarding';

const config: iFacadeConfig['i18nConfig'] = {
	availableLanguages: {
		es: {
			default: 'es',
		},
		ca: {
			default: 'ca',
		},
		pt: {
			default: 'pt'
		},
		default: {
			default: 'ca',
		},
	},
	initialLanguage: 'ca',
};

export { config };
